import React from 'react';
import { Card } from 'react-bootstrap';
import moment from 'moment';

/**
 * Exibe o texto completo de uma ocorrência com metadados (usuário, data).
 */
const MemoTextoOcorrencia = ({ texto, usuario, data }) => {
  return (
    <Card className="shadow-sm mb-3">
      <Card.Header style={{ fontSize: 13, fontWeight: 600 }}>Texto da Ocorrência</Card.Header>
      <Card.Body className="p-2">
        {(usuario || data) && (
          <div className="mb-1" style={{ fontSize: 12, color: '#555' }}>
            {data && <span>Data: {moment(data).format('DD/MM/YYYY')} </span>}
            {usuario && <span> | Usuário: {usuario}</span>}
          </div>
        )}
        <pre
          style={{
            fontSize: 13,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            minHeight: 80,
            maxHeight: 200,
            overflowY: 'auto',
            background: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: 4,
            padding: 8,
            margin: 0,
          }}
        >
          {texto || <span className="text-muted">Selecione uma data no grid acima para exibir o texto.</span>}
        </pre>
      </Card.Body>
    </Card>
  );
};

export default MemoTextoOcorrencia;
